import * as IsActive from '../../components/is_active'

export const FETCH_DROPS = 'FETCH_DROPS'
export const CLEAR_DROP = 'CLEAR_DROP'
export const UPDATE_FILTER = 'UPDATE_DROPS_FILTER'
export const UPDATE_SELECTED_DATE = `${FETCH_DROPS}_${IsActive.UPDATE_SELECTED_DATE}`



// WEBPACK FOOTER //
// ./src/pages/drops/constants.ts